import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

import { addMediaIfOK, updateAddMediaFormValues, clearAddMediaFormValues, hideAddSceneMediaModal } from '../../actions';
import { AddSceneMediaModal } from './AddSceneMediaModal';
import { downloadUrl } from '../../helpers';

class AddSceneMediaModalController extends Component {
    constructor(props) {
        super(props);

        this.formUpdated = this.formUpdated.bind(this);
        this.formSubmitted = this.formSubmitted.bind(this);
    }

    formSubmitted(event) {
        event.preventDefault();
        const {addMediaIfOK, data, scene, hideAddSceneMediaModal, clearAddMediaFormValues} = this.props;

        addMediaIfOK(scene, data)
            .then(clearAddMediaFormValues)
            .then(hideAddSceneMediaModal);
    }

    formUpdated(event) {
        const {updateAddMediaFormValues, data} = this.props;
        const {target} = event;

        const key = _.camelCase(target.name);

        updateAddMediaFormValues({
            ...data,
            [key]: target.value,
            [`${key}Valid`]: isValid(key, target.value)
        });
    }

    render() {
        const {show, hideAddSceneMediaModal, clearAddMediaFormValues, scene, data} = this.props;

        return (
            <AddSceneMediaModal
                show={show}
                hide={() => {
                    clearAddMediaFormValues();
                    hideAddSceneMediaModal();
                }}
                scene={scene}
                previewURL={downloadUrl(data.repository, data.path)}
                data={{
                    pathValidation:       validationState(data.pathValid),
                    repositoryValidation: validationState(data.repositoryValid),
                    mediaNameValidation:  validationState(data.mediaNameValid),
                    datasetValidation:    validationState(data.datasetValid),
                    languageValidation:   validationState(data.languageValid),
                    formValid:            formValid(data)
                }}
                updated={this.formUpdated}
                submitted={this.formSubmitted}
                />
        );
    }
}

const isValid = (name, value) => {
    switch(name) {
        case 'path':       return /\..{3,}$/.test(value); // make sure the path has an extension of at least 3 characters
        case 'repository': return !!value;                 
        case 'mediaName':  return /.*\..{1,}/.test(value); 
        case 'dataset':    return !isNaN(value);           
        case 'language':   return !!value;                 
        default:           return false;
    }
};

const validationState = isValid => {
    return isValid ? 'success' : 'error';
};

const formValid = data => {
    return data.pathValid &&
        data.repositoryValid &&
        data.mediaNameValid &&
        data.datasetValid &&
        data.languageValid;
};

AddSceneMediaModalController.propTypes = {
    show:                     PropTypes.bool.isRequired,
    hideAddSceneMediaModal:   PropTypes.func.isRequired,
    scene:                    PropTypes.string.isRequired,
    addMediaIfOK:             PropTypes.func.isRequired,
    updateAddMediaFormValues: PropTypes.func.isRequired,
    data:                     PropTypes.object.isRequired,
    clearAddMediaFormValues:  PropTypes.func.isRequired
};

const mapDispatchToProps = {
    addMediaIfOK,
    updateAddMediaFormValues,
    clearAddMediaFormValues,
    hideAddSceneMediaModal
};

const mapStateToProps = state => ({
    scene: state.scene.current,
    previewBlob: state.ui.previewMedia.previewData,
    data: state.ui.addSceneMediaData,
    show: state.ui.addSceneMedia.show
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddSceneMediaModalController);



// WEBPACK FOOTER //
// ./src/components/addSceneMediaModal/AddSceneMediaModalController.js